// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Utils = require("../../../utils/Utils.bs.js");
var Core__List = require("@rescript/core/src/Core__List.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Utils__Regex = require("../../../utils/Utils__Regex.bs.js");
var Form__Helpers = require("./Form__Helpers.bs.js");
var EmailRegexJs = require("./emailRegex.js").default;
var Form__Validators__Email = require("./Form__Validators__Email.bs.js");

function isRequired(str) {
  var x = Core__Option.map(str, (function (prim) {
          return prim.trim();
        }));
  if (x !== undefined && x !== "") {
    return {
            TAG: "Ok",
            _0: "Valid"
          };
  } else {
    return {
            TAG: "Error",
            _0: "is required"
          };
  }
}

var emailRegex = EmailRegexJs;

function isEmail(email) {
  if (Form__Validators__Email.isEmail(email)) {
    return {
            TAG: "Ok",
            _0: "Valid"
          };
  } else {
    return {
            TAG: "Error",
            _0: "must be a valid email address"
          };
  }
}

function isPhone(phone) {
  if (Form__Helpers.stripNonDigits(phone).length === 10) {
    return {
            TAG: "Ok",
            _0: "Valid"
          };
  } else {
    return {
            TAG: "Error",
            _0: "must be a valid, 10 digit phone number"
          };
  }
}

function boolOfValidation(x) {
  if (x.TAG === "Ok" && x._0 === "Valid") {
    return true;
  } else {
    return false;
  }
}

function makeNameRegexStr(param) {
  var firstNameEscaped = Utils__Regex.$$escape(param.firstName);
  var lastNameEscaped = Utils__Regex.$$escape(param.lastName);
  return "\\b" + firstNameEscaped + "\\s+" + lastNameEscaped + "\\b";
}

function makeDisplayNameRegexStr(displayName) {
  var str = displayName.split(" ").filter(function (x) {
            return x !== "";
          }).map(Utils__Regex.$$escape).join("\\s+");
  return "\\b" + str + "\\b";
}

function makeRegex(currentUser, accountOwner) {
  var regexes = Core__List.concat({
        hd: Utils__Regex.phoneRegexStr,
        tl: {
          hd: Utils__Regex.emailRegexStr,
          tl: {
            hd: makeNameRegexStr(currentUser),
            tl: {
              hd: Core__Option.map(currentUser.displayName, makeDisplayNameRegexStr),
              tl: /* [] */0
            }
          }
        }
      }, currentUser.id === accountOwner.id ? /* [] */0 : ({
            hd: makeNameRegexStr(accountOwner),
            tl: {
              hd: Core__Option.map(accountOwner.displayName, makeDisplayNameRegexStr),
              tl: /* [] */0
            }
          }));
  return new RegExp((function (list) {
                  return Utils.List.join("|", undefined, list);
                })(Core__List.filterMap(regexes, (function (x) {
                        return x;
                      }))), "i");
}

function validate(currentUser, accountOwner, text) {
  var regex = makeRegex(currentUser, accountOwner);
  var res = Core__Option.map((function (__x) {
            return Caml_option.null_to_opt(regex.exec(__x));
          })(text), (function (v) {
          return v;
        }));
  if (res !== undefined) {
    return {
            TAG: "Error",
            _0: Core__Option.flatMap(res[0], (function (prim) {
                    if (prim == null) {
                      return ;
                    } else {
                      return Caml_option.some(prim);
                    }
                  }))
          };
  } else {
    return {
            TAG: "Ok",
            _0: "Valid"
          };
  }
}

var PersonalInfoValidation = {
  makeNameRegexStr: makeNameRegexStr,
  makeDisplayNameRegexStr: makeDisplayNameRegexStr,
  makeRegex: makeRegex,
  validate: validate
};

exports.isRequired = isRequired;
exports.emailRegex = emailRegex;
exports.isEmail = isEmail;
exports.isPhone = isPhone;
exports.boolOfValidation = boolOfValidation;
exports.PersonalInfoValidation = PersonalInfoValidation;
/* emailRegex Not a pure module */
